import {useQuery} from '@tanstack/react-query';
import * as DeploymentAccountGroupsService from '../services/DeploymentAccountGroupsService';

// Query keys
export const deploymentAccountGroupsKeys = {
    all: ['deployment-account-groups'] as const,
    lists: () => [...deploymentAccountGroupsKeys.all, 'list'] as const,
    list: () => [...deploymentAccountGroupsKeys.lists()] as const,
    details: () => [...deploymentAccountGroupsKeys.all, 'detail'] as const,
    detail: (id: string) => [...deploymentAccountGroupsKeys.details(), id] as const,
};

// Hooks
export const useDeploymentAccountGroupsQuery = () => {
    return useQuery({
        queryKey: deploymentAccountGroupsKeys.list(),
        queryFn: () => DeploymentAccountGroupsService.fetchRecords(),
    });
};

export const useDeploymentAccountGroupQuery = (id: string) => {
    return useQuery({
        queryKey: deploymentAccountGroupsKeys.detail(id),
        queryFn: () => DeploymentAccountGroupsService.fetch(id),
        enabled: !!id,
    });
};
